import React, { useEffect, useRef, useState } from 'react';
import '../css/adsSize.css';

const AdsBanner = () => {
  const adRef = useRef(null);
  const [adLoaded, setAdLoaded] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        setIsVisible(entry.contentRect.width > 0);
      });
    });

    const currentAdRef = adRef.current; // Capture the current value of adRef

    if (currentAdRef) {
      observer.observe(currentAdRef);
    }

    return () => {
      if (currentAdRef) {
        observer.unobserve(currentAdRef);
      }
    };
  }, []);

  useEffect(() => {
    const loadAd = () => {
      if (window.adsbygoogle && adRef.current && isVisible) {
        try {
          window.adsbygoogle.push({});
          setAdLoaded(true);
        } catch (e) {
          console.error('Adsense error:', e);
          setAdLoaded(false);
        }
      }
    };

    // Attempt to load the ad when visible
    if (isVisible) {
      loadAd();
    }

    // Retry loading the ad every 1 minute if not loaded
    const intervalId = setInterval(() => {
      if (!adLoaded) {
        loadAd();
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [isVisible, adLoaded]);

  return (
    <div className="ads-container">
      {adLoaded ? (
        <ins className="adsbygoogle"
          data-ad-client="ca-pub-8143656990478270"
          data-ad-slot="9484403816"
          ref={adRef}
          style={{ display: 'block' }}
        ></ins>
      ) : (
        <div className="ads-fallback">
          Ad
        </div>
      )}
    </div>
  );
};

export default AdsBanner;
